module.exports = __webpack_public_path__ + "static/media/s_v9_t3_1.a4b833c2.mp3";